import "../styles/testimonials.css";

function Testimonials() {
  return (
    <section className="testimonials">

      <div className="testimonials-header">
        <span><h4>Testimonials</h4></span>
        <p>
          Read genuine Google reviews from our happy customers who trusted
          Jagadish Hearing Aids.
        </p>
      </div>

      <div className="reviews-container" data-aos="zoom-in">
        <div
          className="elfsight-app-182c03f2-5997-4f7d-b1d6-96c756b65708"
          data-elfsight-app-lazy
        ></div>
      </div>

    </section>
  );
}

export default Testimonials;